import { Chart } from "../../../../src/articles/annual-report/2020/04-achievements/01-assessment/chart/chart.tsx";
import * as React from 'react';
export default {
  Chart,
  React
};